import { Link } from 'react-router-dom';
import type { Post } from '@/mocks/posts';

export default function Ticker({ posts }: { posts: Post[] }) {
  const items = posts.slice(0, 6);
  const loop = [...items, ...items];

  return (
    <div className="flex items-center gap-4 border-y border-background-200 bg-background-100 py-2.5">
      <span className="ml-4 flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50 md:ml-8">
        <i className="ri-flashlight-fill" aria-hidden="true"></i>
        今日更新
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track whitespace-nowrap">
          {loop.map((post, index) => (
            <Link
              key={`${post.id}-${index}`}
              to={`/post/${post.id}`}
              className="mr-8 inline-flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              <i className="ri-arrow-right-s-fill text-primary-500" aria-hidden="true"></i>
              {post.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}